import React from 'react';
import PropTypes from 'prop-types';
import HeadshotComponent from './headshot';
import moment from 'moment';

const MessageListRun = ({ run = [], creator, currentUser, isGroupConversation }) => {
  if (!run.length) { return null; }
  const fromCurrentUser = creator.id === currentUser.id;

  const renderMessageCreator = () => {
    if (fromCurrentUser || !isGroupConversation) { return null; }

    return (
      <div className="mb--5" key={creator.displayName}>
        <div className="message-list-creator-name dark-gray t6 w2-5">{creator.displayName}</div>
      </div>
    );
  }

  const renderGutter = () => {
    if (fromCurrentUser || !isGroupConversation) { return null; }

    return (
      <div className="message-list-gutter">
        <HeadshotComponent user={creator} className="tiny" />
      </div>
    );
  }

  return (
    <div className="message-list-run">
      {renderGutter()}
      <div className="run-rows">
        {renderMessageCreator()}
        {run}
      </div>
    </div>
  );
};

MessageListRun.propTypes = {
  run: PropTypes.array.isRequired,
  creator: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired
};

export default MessageListRun;
